// 네이버 언론사 공식 홈 45곳의 이름과 홈페이지 링크를 확인했어요: 2026-10-18. 기사 fetch 없음.
export const PUBLISHERS=[
  {
    "pressId": "001",
    "name": "연합뉴스",
    "domain": "yna.co.kr"
  },
  {
    "pressId": "005",
    "name": "국민일보",
    "domain": "kmib.co.kr"
  },
  {
    "pressId": "003",
    "name": "뉴시스",
    "domain": "newsis.com"
  },
  {
    "pressId": "009",
    "name": "매일경제",
    "domain": "mk.co.kr"
  },
  {
    "pressId": "011",
    "name": "서울경제",
    "domain": "sedaily.com"
  },
  {
    "pressId": "008",
    "name": "머니투데이",
    "domain": "mt.co.kr"
  },
  {
    "pressId": "016",
    "name": "헤럴드경제",
    "domain": "heraldcorp.com"
  },
  {
    "pressId": "014",
    "name": "파이낸셜뉴스",
    "domain": "fnnews.com"
  },
  {
    "pressId": "015",
    "name": "한국경제",
    "domain": "hankyung.com"
  },
  {
    "pressId": "020",
    "name": "동아일보",
    "domain": "donga.com"
  },
  {
    "pressId": "018",
    "name": "이데일리",
    "domain": "edaily.co.kr"
  },
  {
    "pressId": "021",
    "name": "문화일보",
    "domain": "munhwa.com"
  },
  {
    "pressId": "025",
    "name": "중앙일보",
    "domain": "joongang.co.kr"
  },
  {
    "pressId": "023",
    "name": "조선일보",
    "domain": "chosun.com"
  },
  {
    "pressId": "022",
    "name": "세계일보",
    "domain": "segye.com"
  },
  {
    "pressId": "029",
    "name": "디지털타임스",
    "domain": "dt.co.kr"
  },
  {
    "pressId": "028",
    "name": "한겨레",
    "domain": "hani.co.kr"
  },
  {
    "pressId": "030",
    "name": "전자신문",
    "domain": "etnews.com"
  },
  {
    "pressId": "033",
    "name": "주간경향",
    "domain": "weekly.khan.co.kr"
  },
  {
    "pressId": "031",
    "name": "아이뉴스24",
    "domain": "inews24.com"
  },
  {
    "pressId": "032",
    "name": "경향신문",
    "domain": "khan.co.kr"
  },
  {
    "pressId": "037",
    "name": "주간동아",
    "domain": "weekly.donga.com"
  },
  {
    "pressId": "047",
    "name": "오마이뉴스",
    "domain": "ohmynews.com"
  },
  {
    "pressId": "036",
    "name": "한겨레21",
    "domain": "h21.hani.co.kr"
  },
  {
    "pressId": "055",
    "name": "SBS",
    "domain": "news.sbs.co.kr"
  },
  {
    "pressId": "056",
    "name": "KBS",
    "domain": "news.kbs.co.kr"
  },
  {
    "pressId": "052",
    "name": "YTN",
    "domain": "ytn.co.kr"
  },
  {
    "pressId": "057",
    "name": "MBN",
    "domain": "mbn.co.kr"
  },
  {
    "pressId": "082",
    "name": "부산일보",
    "domain": "busan.com"
  },
  {
    "pressId": "081",
    "name": "서울신문",
    "domain": "seoul.co.kr"
  },
  {
    "pressId": "087",
    "name": "강원일보",
    "domain": "kwnews.co.kr"
  },
  {
    "pressId": "088",
    "name": "매일신문",
    "domain": "imaeil.com"
  },
  {
    "pressId": "092",
    "name": "지디넷코리아",
    "domain": "zdnet.co.kr"
  },
  {
    "pressId": "214",
    "name": "MBC",
    "domain": "imnews.imbc.com"
  },
  {
    "pressId": "123",
    "name": "조세일보",
    "domain": "joseilbo.com"
  },
  {
    "pressId": "119",
    "name": "데일리안",
    "domain": "dailian.co.kr"
  },
  {
    "pressId": "215",
    "name": "한국경제TV",
    "domain": "wowtv.co.kr"
  },
  {
    "pressId": "277",
    "name": "아시아경제",
    "domain": "asiae.co.kr"
  },
  {
    "pressId": "366",
    "name": "조선비즈",
    "domain": "biz.chosun.com"
  },
  {
    "pressId": "421",
    "name": "뉴스1",
    "domain": "news1.kr"
  },
  {
    "pressId": "422",
    "name": "연합뉴스TV",
    "domain": "yonhapnewstv.co.kr"
  },
  {
    "pressId": "437",
    "name": "JTBC",
    "domain": "news.jtbc.co.kr"
  },
  {
    "pressId": "448",
    "name": "TV조선",
    "domain": "news.tvchosun.com"
  },
  {
    "pressId": "449",
    "name": "채널A",
    "domain": "ichannela.com"
  },
  {
    "pressId": "469",
    "name": "한국일보",
    "domain": "hankookilbo.com"
  }
] as const;
// 원문을 가져오지 않아요. 확인되지 않은 발행처는 도메인을 그대로 제안해요.
export function suggestPublisher(raw:string):string {try{const parsed=new URL(raw);const host=parsed.hostname.replace(/^www\./,'');const press=host==='n.news.naver.com'?parsed.pathname.match(/^\/article\/(\d{3})\//)?.[1]:undefined;return PUBLISHERS.find(row=>press?row.pressId===press:host===row.domain||host.endsWith('.'+row.domain))?.name??host;}catch{return '';}}
export function suggestDate(raw:string):string|undefined {const match=raw.match(/(20\d{2})[/-]?(0[1-9]|1[0-2])[/-]?([0-2]\d|3[01])/);if(!match)return undefined;const value=`${match[1]}-${match[2]}-${match[3]}`;const date=new Date(value);return Number.isFinite(date.getTime()) && date.toISOString().slice(0,10)===value?value:undefined;}
